import  {  useEffect  } from 'react'
import PropTypes from 'prop-types'
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as authActions from 'action/auth'
import { translate } from 'react-i18next'
import { push } from 'react-router-redux'


const PingAuthError = (props) => {
  PingAuthError.propTypes = {
    getUserInfo: PropTypes.func.isRequired
  }

  const error = {
    dsMessage: "Erro na autenticação",
    cdStatus: 401
  }

  const {dispatch, loginError} = props

  useEffect(() => {
        dispatch(loginError(error))
        dispatch(push('/login'))

  }, [])

  return null
}

const mapStateToProps = ({ auth }) => ({
  error: auth.error
})
/**
 * Maps actions and dispatch them to props
 * @param {Function} dispatch
 * @return {Object} props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authActions, dispatch)
/* istanbul ignore next */
const PingAuthLoginTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PingAuthError)

export default connect(mapStateToProps, mapDispatchToProps)(PingAuthLoginTranslated)

export { PingAuthError }
